import { createPaginatedList } from "MODULES/shared/pagination";
import api from "APP_ROOT/api";
import _ from "lodash";

export default createPaginatedList({
  listId: "approvedRepairStations",
  fetch: params =>
    api.companies.search(
      _.merge(params, {
        repair_station: true,
        sort: "name",
        reverse: false
      })
    )
});



// WEBPACK FOOTER //
// ./app/modules/ApprovedRepairStations/pagination.js